import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";
import { useSelector } from "react-redux";
import AccountSummeryUser from "./AccountSummeryTabsContent/AccountSummeryUser";
import AccountSummeryIncome from "./AccountSummeryTabsContent/AccountSummeryIncome";
import AccountSummeryPerformance from "./AccountSummeryTabsContent/AccountSummeryPerformance";
import AccountSummeryCategoryFilter from "./AccountSummeryCategoryFilter";

const AccountSummeryTabs = ({ sortConfig, setSortConfig, onRefresh }: any) => {
  const [value, setValue] = React.useState(0);
  const { overviewAccountSummaryData } = useSelector(
    (state: any) => state.bizDevelopmentDashboardMobile,
  );

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  interface TabPanelProps {
    children?: React.ReactNode;
    value: number;
    index: number;
  }

  function TabPanel({ children, value, index }: TabPanelProps) {
    return (
      <div hidden={value !== index}>
        {value === index && <Box sx={{ pt: 1 }}>{children}</Box>}
      </div>
    );
  }

  const sortedData = React.useMemo(() => {
    const filteredData = overviewAccountSummaryData?.query_output || [];
    if (!sortConfig.field) return filteredData;
    const field = sortConfig.field;
    const getDateValue = (item: any) =>
      new Date(item.start_of_week || item.date || item.month).getTime();
    return [...filteredData].sort((a: any, b: any) => {
      if (field === "Date") {
        const aDate = getDateValue(a);
        const bDate = getDateValue(b);
        return sortConfig.direction === "asc" ? aDate - bDate : bDate - aDate;
      }
      const aVal = a[field];
      const bVal = b[field];
      if (aVal == null) return 1;
      if (bVal == null) return -1;
      if (typeof aVal === "string") {
        return sortConfig.direction === "asc"
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      }
      return sortConfig.direction === "asc" ? aVal - bVal : bVal - aVal;
    });
  }, [overviewAccountSummaryData, sortConfig]);

  return (
    <>
      <Tabs
        value={value}
        onChange={handleChange}
        centered
        sx={{
          mt: spacing.Spacing.lg1.$value,
          "& .MuiTabs-scrollButtons": {
            color: colors.GrayDarkMode[700].$value,
          },
          background: colors.GrayLightMode[100].$value,
          borderTop: "3px solid" + colors.GrayLightMode[100].$value,
          borderBottom: "3px solid" + colors.GrayLightMode[100].$value,
          borderRadius: spacing.Radius.md.$value,
          minHeight: spacing.Spacing["3xl"].$value,
        }}
        TabIndicatorProps={{
          sx: {
            height: spacing.Spacing.none.$value,
          },
        }}
      >
        {["User", "Income", "Performance"].map((label) => (
          <Tab
            key={label}
            label={label}
            disableRipple
            sx={{
              width: "32.8%",
              color: colors.GrayDarkMode[500].$value,
              textTransform: "none",
              fontWeight: typography.Font_weight.Regular.$value,
              borderRadius: spacing.Radius.xs.$value,
              fontSize: typography.Size.Text.xs.$value,
              lineHeight: typography.Line_height.text.xs.$value,
              padding: 0,
              minHeight: spacing.Spacing["3xl"].$value,
              "&.Mui-selected": {
                color: colors.GrayDarkMode[900].$value,
                fontWeight: typography.Font_weight.Bold.$value,
                backgroundColor: colors.Base.White.$value + "!important",
              },
              "&:hover": { backgroundColor: "transparent" },
            }}
          />
        ))}
      </Tabs>

      {/* 🔽 SORT BY / BRAND COUNT / DOWNLOAD / REFRESH */}
      <Box sx={{ pt: 1 }}>
        <AccountSummeryCategoryFilter
          sortConfig={sortConfig}
          setSortConfig={setSortConfig}
          onRefresh={onRefresh}
        />
      </Box>

      {/* 🔽 TAB CONTENTS */}
      <TabPanel value={value} index={0}>
        <AccountSummeryUser sortedData={sortedData} />
      </TabPanel>

      <TabPanel value={value} index={1}>
        <AccountSummeryIncome sortedData={sortedData} />
      </TabPanel>

      <TabPanel value={value} index={2}>
        <AccountSummeryPerformance sortedData={sortedData} />
      </TabPanel>
    </>
  );
};

export default AccountSummeryTabs;
